export default "__VITE_ASSET__CCHqOTvZ__"